<template>
    <v-icon
        v-if="!isCustomImg"
        v-bind="$attrs"
        :icon="name"
        :color="color"
        :size="size"
        :disabled="disabled"
        :class="[iconClass, { 'cursor-pointer': clickable, 'v-icon--clickable': clickable }]"
        @click="handleClick"
    >
    </v-icon>
    <img
        v-else
        :src="name"
        :alt="alt"
        :style="{ width: computedSizeForImg, height: computedSizeForImg, color: color }"
        :disabled="disabled"
        :class="[iconClass, { 'cursor-pointer': clickable, 'v-icon--clickable': clickable }]"
        v-bind="$attrs"
        @click="handleClick"
    />
</template>

<script setup lang="ts">
    import { computed } from 'vue';

    interface Props {
        name?: string;
        color?: string;
        size?: 'x-small' | 'small' | 'default' | 'large' | 'x-large' | number;
        disabled?: boolean;
        clickable?: boolean;
        class?: string | Record<string, boolean> | Array<string | Record<string, boolean>>;
        isCustomImg?: boolean;
        alt?: string;
    }
    const props = withDefaults(defineProps<Props>(), {
        color: 'inherit',
        size: 'default',
        disabled: false,
        clickable: false,
        class: '',
        isCustomImg: false,
        alt: '',
    });

    const emit = defineEmits<{
        (e: 'click', event: Event): void;
    }>();

    const iconClass = computed(() => props.class);

    const computedSizeForImg = computed(() => {
        if (!props.size) return undefined;

        const sizeMap: Record<string, string> = {
            'x-small': '12px',
            'small': '16px',
            'default': '24px',
            'large': '32px',
            'x-large': '40px',
        };

        if (typeof props.size === 'string' && sizeMap[props.size]) {
            return sizeMap[props.size];
        }

        return typeof props.size === 'number' ? `${props.size}px` : props.size;
    });

    const handleClick = (event: Event) => {
        if (!props.disabled) {
            emit('click', event);
        }
    };
</script>
